import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from 'redux/store'
import { Provider } from 'react-redux'
import Modal from 'react-modal'
import { LocalToastProvider } from 'react-local-toast'
import { UploadContextProvider } from './contexts/UploadContext'

Modal.setAppElement('#root')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router basename={process.env.REACT_APP_BASE_PATH}>
      <LocalToastProvider>
        <UploadContextProvider>
          <App />
        </UploadContextProvider>
      </LocalToastProvider>
    </Router>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
